// Here to break circular dependency from prompt.ts
export const BASH_TOOL_NAME = 'Bash'
